'use strict';

import React from 'react';
import PropTypes from 'prop-types';

export default class StateInputField extends React.Component {
  static propTypes = {
    shortName: PropTypes.string,
    longName: PropTypes.string,
    updater: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      shortName: props.shortName,
      longName: props.longName,
    };
  }

  componentDidMount() {
    this.props.updater.addListener('State.set', this.listener);
  }

  componentWillUnmount() {
    this.props.updater.removeListener('State.set');
  }

  listener = (data) => {
    this.setState({ shortName: data.short_name, longName: data.long_name });
  }

  render() {
    return (
      <div>
        <input
          type="hidden"
          value={this.state.shortName}
          name="event[state]"
          id="event_state" />
        <input
          readOnly={true}
          className="form-control"
          type="text"
          name="event[state_long_name]"
          id="event_state_long_name"
          value={this.state.longName} />
      </div>
    );
  }
}
